import { render } from "./CraIssueList.vue?vue&type=template&id=ae1c2ede"
import script from "./CraIssueList.js?vue&type=script&lang=js"
export * from "./CraIssueList.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__